import type { $Fetch } from "ofetch";
const controller = "/Permissao";
/**
 * Tipo da reposta da API da validação de permissão
 */
export type PermissaoResponse = {
  permissao: string;
  temPermissao: boolean;
};

/**
 * Classe de gerenciamento de chamadas da API das permissões
 *
 * @class
 */
export default class PermissionApi {
  /**
   * Instância da dependência da API (ofetch)
   */
  private api;

  /**
   * Cria uma nova instância da classe PermissionApi.
   * @constructor
   * @param api - Instância da dependência da API (ofetch).
   */
  constructor(api: $Fetch) {
    this.api = api;
  }

  /**
   * @param registro - Nome do módulo aplicação
   * @returns objeto contendo as informações da permissão do usuário
   */
  validatePermission(registro: string) {
    return this.api<PermissaoResponse>(`${controller}/ValidarPermissao`, {
      method: "GET",
      params: {
        registro,
      },
    });
  }

  /**
   * Realiza a busca pelas permissões do módulo/registro informado
   * @param registro - Nome do módulo aplicação
   * @returns objeto contendo as informações da permissão do usuário
   */
  preencherPermissoes(registro: string) {
    return this.api<PermissaoResponse>(`${controller}/PreencherPermissoes`, {
      method: "GET",
      params: {
        registro,
      },
    });
  }

  /**
   * Realiza a busca pelas permissões do módulo/registro informado para o usuário emissor informado
   * @param registroModuloAplicacao - Nome do módulo aplicação
   * @param codEmissor - Código do usuário emissor
   * @returns objeto contendo as informações da permissão do usuário
   */
  listarPermissoesUsuarioEmissor(
    registroModuloAplicacao: string,
    codEmissor: number,
  ) {
    return this.api<PermissaoResponse>(
      `${controller}/ListarPermissoesUsuarioEmissor`,
      {
        method: "GET",
        params: {
          registroModuloAplicacao,
          codEmissor,
        },
      },
    );
  }

  /**
   * Salva a permissão do usuário para o módulo/registro informado.
   * @param codPermissao - Código da permissão
   * @param codGrupoUsuario - Código do grupo de usuário
   * @param codUsuario - Código do usuário
   * @param codModuloAplicacao - Código do módulo aplicação
   * @param codUsuarioModificacao - Código do usuário que realizou a modificação
   * @param status - Status da permissão (true para permissão concedida, false para permissão revogada)
   * @returns objeto contendo as informações da permissão do usuário
   */
  permissaoSalvar(
    codPermissao: number | null,
    codGrupoUsuario: number,
    codUsuario: number,
    codModuloAplicacao: number,
    status: boolean,
  ) {
    return this.api<ApplicationModule[]>(`${controller}/PermissaoSalvar`, {
      method: "POST",
      params: {
        codPermissao,
        codGrupoUsuario,
        codUsuario,
        codModuloAplicacao,
        status,
      },
    });
  }

  /**
   * Exclui a permissão do usuário para o módulo/registro informado.
   * @param codPermissao - Código da permissão
   * @param codUsuario - Código do usuário
   * @param codModuloAplicacao - Código do módulo aplicação
   * @returns objeto contendo as informações da permissão do usuário
   */
  permissaoDeletar(
    codPermissao: number,
    codUsuario: number,
    codModuloAplicacao: number,
  ) {
    return this.api<PermissaoResponse>(`${controller}/PermissaoDeletar`, {
      method: "POST",
      params: {
        codPermissao,
        codUsuario,
        codModuloAplicacao,
      },
    });
  }
}
